import { useEffect, useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import {
  buildEvolutionNoteContentHtml,
  EVOLUTION_NOTE_PRINT_PAGE_STYLES,
  readEvolutionNotePreviewPayload,
} from '../lib/evolutionNoteDocument';

/**
 * Vista previa de nota de evolución en pestaña nueva (imprimible → PDF en el navegador).
 * Los botones usan React (no onclick inline) para respetar CSP script-src-attr 'none'.
 */
export default function AdminEvolutionNotePreview() {
  const payload = useMemo(() => readEvolutionNotePreviewPayload(), []);
  const [searchParams] = useSearchParams();
  const autoPrint = searchParams.get('print') === '1';

  const contentHtml = useMemo(() => {
    if (!payload) return '';
    return buildEvolutionNoteContentHtml(payload);
  }, [payload]);

  useEffect(() => {
    document.body.classList.add('evolution-note-preview-open');
    return () => document.body.classList.remove('evolution-note-preview-open');
  }, []);

  useEffect(() => {
    if (payload) {
      document.title = `Nota de evolución — ${payload.patientName || 'Paciente'}`;
    }
  }, [payload]);

  useEffect(() => {
    if (!autoPrint || !payload) return undefined;
    const timer = window.setTimeout(() => window.print(), 400);
    return () => window.clearTimeout(timer);
  }, [autoPrint, payload]);

  if (!payload) {
    return (
      <div className="min-h-[40vh] flex flex-col items-center justify-center gap-4 p-8 text-center">
        <p className="text-muted-foreground">
          No hay datos de la nota para mostrar. Ábrala desde el expediente y pulse Imprimir PDF.
        </p>
        <Link to="/admin/expedientes" className="text-primary underline">
          Volver a expedientes
        </Link>
      </div>
    );
  }

  return (
    <>
      <style>{EVOLUTION_NOTE_PRINT_PAGE_STYLES}</style>
      <div className="evolution-note-print-page has-toolbar">
        <div className="evolution-note-print-toolbar">
          <button type="button" onClick={() => window.print()}>
            Imprimir / Guardar PDF
          </button>
          <button type="button" onClick={() => window.close()}>
            Cerrar
          </button>
          <span className="toolbar-hint">
            En el diálogo de impresión elija «Guardar como PDF» o imprima en papel.
          </span>
        </div>
        <div className="doc-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />
      </div>
    </>
  );
}
